<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      regionPopupShow: false
    }
  },
  computed: {
    ...mapGetters(['finalRegionCode', 'openRegionList', 'canSwitchRegion']),
    showRegion(){
      return this.openRegionList.find(item => item.B === this.finalRegionCode).C
    },
    regionOptionList(){
      return this.openRegionList.map(item => item.C)
    },
    regionSelectIndex(){
      return this.openRegionList.findIndex(item => item.B === this.finalRegionCode)
    }
  },

  methods: {
    onRegionClick(){
      this.regionPopupShow = true
    },

    onClickRegionItem(index){
      this.$store.dispatch('config/setManulRegionCode', this.openRegionList[index].B)
    }
  }
}
</script>
